import { omit } from "lodash";
import React, { createElement } from "react";

import { PlayingSurfaceData, Sport } from "../../../redux/slices";
import { CourtOptions } from "../../../types";

const getSportColorOverride = (sport: Sport): string | undefined => {
  switch (sport) {
    case Sport.BASKETBALL:
    case Sport.SOCCER:
      return "#fff";

    case Sport.HOCKEY:
      return undefined;
  }
};

export interface PlayingSurfaceLinesProps {
  playingSurfaceData: PlayingSurfaceData;
  courtOptions: CourtOptions;
  sport: Sport;
  showBackground: boolean;
}

export const PlayingSurfaceLines = ({
  playingSurfaceData,
  courtOptions,
  sport,
  showBackground,
}: PlayingSurfaceLinesProps) => {
  const { clipPath, elements } = playingSurfaceData;

  return (
    <>
      {clipPath && (
        <defs>
          <clipPath id={clipPath.id}>{createElement(clipPath.svgElement, omit(clipPath, "svgElement", "id"))}</clipPath>
        </defs>
      )}

      <g>
        {elements
          ?.filter((element) => courtOptions[element.sportElement] !== false)
          ?.map((element, index) => {
            const {
              svgElement,
              shotChartEnabled: _shotChartEnabled,
              fdEnabled: _fdEnabled,
              sportElement,
              ...restProps
            } = element;

            const colorOverride = getSportColorOverride(sport);
            const fillOverride = showBackground && element.fill === "#000" ? colorOverride : undefined;
            const strokeOverride = showBackground && element.stroke === "#000" ? colorOverride : undefined;

            return createElement(svgElement, {
              ...restProps,
              id: sportElement,
              ...(fillOverride ? { fill: fillOverride } : {}),
              ...(strokeOverride ? { stroke: strokeOverride } : {}),
              key: index,
            });
          })}
      </g>
    </>
  );
};
